// @flow
import type { Styles } from '..'

export const Label = ({ $disabled, $palette, $color }: Styles) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  position: 'relative',
  cursor: 'pointer',
  userSelect: 'none',
  opacity: $disabled ? 0.5 : 1,
  pointerEvents: $disabled ? 'none' : 'initial',
  color: `${$palette($color)}`,
})

export const Input = {
  position: 'absolute',
  opacity: '0',
  cursor: 'pointer',
}

export const CheckContainer = ({
  $checked,
  $focus,
  $palette,
  $color,
  $radio,
}: Styles) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  height: '16px',
  width: '16px',
  marginRight: '10px',
  borderRadius: $radio ? '50px' : '3px',
  fontSize: '18px',
  flexShrink: 0,
  transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  boxShadow: $focus ? `0 0 0 .15rem ${$palette($color).lighten(15)}` : 'none',
  border: `1px solid ${$palette($color)}`,
  backgroundColor: $checked
    ? `${$palette($color)}`
    : `${$palette('transparent')}`,
})

export const CheckMark = ({ $checked, $palette, $checkMarkColor }: Styles) => ({
  display: $checked ? 'block' : 'none',
  color: `${$palette($checkMarkColor || 'white')}`,
})

export const RadioMark = ({ $checked, $palette }: Styles) => ({
  display: $checked ? 'block' : 'none',
  background: `${$palette('white')}`,
  borderRadius: '50px',
  height: '6px',
  width: '6px',
})
